type RouteMap = {
  [key: string]: string;
};
export const routes: RouteMap = {
  form: "/",
  upload: "/upload/:id",
  print: "/print",
};
